
import HeroSection from './HeroSection'

import CardSection from './CardSection'
import AttachCard from './AttachCard'


function HomePage() {
  return (
    <>
    <HeroSection/>
    <AttachCard/>
    <CardSection/>
    </>
  )
}

export default HomePage